<!--
  App shell — the package's AppShell: a 248 px sidebar that collapses to a
  64 px icon rail at 880 px, and a main column holding the sticky topbar over
  the scrolling content. Pages render only their content and wrap their own
  sections in `Card`.
-->
<script lang="ts">
	import type { Snippet } from 'svelte';
	import { AppShell, Content } from '@navitech/ui';
	import AppSidebar from './Sidebar.svelte';
	import StatusBar from './StatusBar.svelte';

	const { children }: { children: Snippet } = $props();
</script>

<AppShell>
	{#snippet sidebar()}
		<AppSidebar />
	{/snippet}
	<StatusBar />
	<Content>
		<div class="mx-auto w-full max-w-[1500px]">
			{@render children()}
		</div>
	</Content>
</AppShell>
